import {
  Component,
  computed,
  inject,
  input,
  output,
  ViewEncapsulation,
  ChangeDetectionStrategy,
} from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';
import { CompanyService } from '@app/features/companies/company.service';
import { CdTDocument } from '@app/features/documents/document.model';
import { AssignmentFormValue } from '../embauche-tabs-form/assignment-form/assignment-form';
import { ContractFormValue } from '../embauche-tabs-form/contract-form/contract-form';
import { DocumentsFormValue } from '../embauche-tabs-form/documents-form/documents-form';
import { EmployeeFormValue } from '../embauche-tabs-form/employee-form/employee-form';
import { SchedulesFormValue } from '../embauche-tabs-form/schedules-form/schedules-form';
import { AssignmentView } from './assignment-view/assignment-view';
import { ContractView } from './contract-view/contract-view';
import { DocumentsView } from './documents-view/documents-view';
import { EmployeeView } from './employee-view/employee-view';
import { SchedulesView } from './schedules-view/schedules-view';

@Component({
  selector: 'app-embauche-view',
  imports: [
    EmployeeView,
    ContractView,
    SchedulesView,
    DocumentsView,
    MatDividerModule,
    AssignmentView,
  ],
  templateUrl: './embauche-view.html',
  styleUrls: ['./embauche-view.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  encapsulation: ViewEncapsulation.None,
})
export class EmbaucheView {
  contact = input.required<EmployeeFormValue>();
  contract = input.required<ContractFormValue>();
  schedules = input.required<SchedulesFormValue>();
  assignment = input.required<AssignmentFormValue>();
  documents = input.required<DocumentsFormValue>();
  /** Les horaires et l'affectation d'avant un avenant, pour en surligner les changements. */
  previousSchedules = input<SchedulesFormValue | null>(null);
  previousAssignment = input<AssignmentFormValue | null>(null);

  openDocument = output<CdTDocument>();

  companyService = inject(CompanyService);

  companyColor = computed(() => {
    const companyId = this.contract().companyId;

    if (!companyId) {
      return undefined;
    }

    try {
      return this.companyService.findById(companyId)?.companyColor;
    } catch {
      return undefined;
    }
  });
}
